import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import translationsCS from './../assets/translations/cs.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'assets-fe';
  private translate = inject(TranslateService);

  constructor() {
    this.translate.setTranslation('cs', translationsCS);
    this.translate.setDefaultLang('cs');
  }
}
